/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CompetenceCompetenceidLangs202,
  PostApiV1CompetenceCompetenceidLangs400,
  PostApiV1CompetenceCompetenceidLangs401,
  PostApiV1CompetenceCompetenceidLangs404,
  PostApiV1CompetenceCompetenceidLangs409,
  PostApiV1CompetenceCompetenceidLangs500,
  PostApiV1CompetenceCompetenceidLangsMutationRequest,
  PostApiV1CompetenceCompetenceidLangsMutationResponse,
  PostApiV1CompetenceCompetenceidLangsPathParams,
} from "../../types/competenceIdiomasController/PostApiV1CompetenceCompetenceidLangs.ts";
import { competenceLangViewModelSchema } from "../competenceLangViewModelSchema.ts";
import { createCompetenceLangRequestViewModelSchema } from "../createCompetenceLangRequestViewModelSchema.ts";

export const postApiV1CompetenceCompetenceidLangsPathParamsSchema = z.object({
  competenceId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1CompetenceCompetenceidLangsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1CompetenceCompetenceidLangs202Schema = z.lazy(
  () => competenceLangViewModelSchema,
) as unknown as ToZod<PostApiV1CompetenceCompetenceidLangs202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CompetenceCompetenceidLangs400Schema =
  z.any() as unknown as ToZod<PostApiV1CompetenceCompetenceidLangs400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CompetenceCompetenceidLangs401Schema =
  z.any() as unknown as ToZod<PostApiV1CompetenceCompetenceidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CompetenceCompetenceidLangs404Schema =
  z.any() as unknown as ToZod<PostApiV1CompetenceCompetenceidLangs404>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1CompetenceCompetenceidLangs409Schema =
  z.any() as unknown as ToZod<PostApiV1CompetenceCompetenceidLangs409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CompetenceCompetenceidLangs500Schema =
  z.any() as unknown as ToZod<PostApiV1CompetenceCompetenceidLangs500>;

export const postApiV1CompetenceCompetenceidLangsMutationRequestSchema = z.lazy(
  () => createCompetenceLangRequestViewModelSchema,
) as unknown as ToZod<PostApiV1CompetenceCompetenceidLangsMutationRequest>;

export const postApiV1CompetenceCompetenceidLangsMutationResponseSchema =
  z.lazy(
    () => postApiV1CompetenceCompetenceidLangs202Schema,
  ) as unknown as ToZod<PostApiV1CompetenceCompetenceidLangsMutationResponse>;
